export const connectNode = 'https://dautenbipolarcenter.org/dauten_backend/' //'https://dauten.dipr.partners.org/dauten_backend/'
export const baseURL = 'https://dautenbipolarcenter.org/' // 'https://dauten.dipr.partners.org/'
